export class AuditFieldworkStepWorkflowUpdateModel {
    approved: boolean;
    comment: string;
    currentStatus: number;
}
